import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('hero-sentinel');
      const offer = document.getElementById('offer');
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 600;
      const offerTop = offer ? offer.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      setVisible(heroBottom < 0 && offerTop >= window.innerHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-66" data-mp="38bgxrs7yhfwg">
      {visible && <motion.a href={CHECKOUT_URL} initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 flex h-[54px] items-center justify-center bg-gold text-[15px] font-extrabold text-navy shadow-[0_-4px_18px_-4px_rgba(201,168,76,0.35)] md:hidden" data-id="element-67" data-mp="38ca1ekbmbpad">
          GET THE COMPLETE ART YEAR™
        </motion.a>}
    </AnimatePresence>;
}